const N = 14; // most chars on one line
module.exports = function splitNametag(nametag) {
  // Return a string with newlines embedded for longer nametags.
  // Always return an uppercased string. Embedded spaces are treated
  // as "break points", and can result in strings longer than "N" being returned.
  nametag = nametag.toUpperCase();
  if (/ /.test(nametag)) {
    return nametag.replace(/ /g, '\n');
  }
  let numlines = Math.ceil(nametag.length / N);
  let balanced = Math.ceil(nametag.length / numlines);
  let result = '';
  while (nametag.length > balanced) {
    result += nametag.substring(0,balanced) + '\n';
    nametag = nametag.substring(balanced);
  }
  return result + nametag;
}



// WEBPACK FOOTER //
// ./src/lib/splitNametag.js